import { Spin, Typography } from 'antd'
import React, { memo } from 'react'
import styles from './LoadingScreen.module.css'

const { Text } = Typography

// Memoized loading screen - content is static and never changes
const LoadingScreen = memo(function LoadingScreen() {
  return (
    <div className={styles.loadingScreen}>
      <div className={styles.loadingContent}>
        <Spin size="large" />
        <Text className={styles.loadingText}>Loading, please wait...</Text>
      </div>
    </div>
  )
})

export default LoadingScreen
